import { useId } from "react"

type Props = {
  label: string
  onChange: React.ChangeEventHandler<HTMLInputElement>
  checked?: boolean
}

const Checkbox = ({ label, onChange, checked }: Props) => {
  const id = useId()
  return (
    <div className="form-check icon-check">
      <input
        onChange={onChange}
        checked={checked}
        className="form-check-input"
        type="checkbox"
        id={id}
      />
      <label className="form-check-label" htmlFor={id}>
        {label}
      </label>
      <i className="icon-check-1 fa fa-circle color-gray-dark font-16" />
      <i className="icon-check-2 fa fa-check-circle font-16 color-highlight" />
    </div>
  )
}

export default Checkbox
